import { Component } from '@angular/core';

@Component({
  selector: 'kt-bridgepay-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class TransactionDashboardComponent {}
